import { Button } from "@chakra-ui/react";
import type React from "react";
import { BsTrash, BsPlay } from "react-icons/bs";

interface CardProps {
    name: string;
    onDelete: () => void;
    onConfigure: () => void;
}

const Card: React.FC<CardProps> = ({ name, onDelete, onConfigure }) => {
    return (
        <div className="bg-[#3f3f3f] p-4 rounded-md w-full max-w-sm">
            <p className="text-white font-semibold mb-4">
                <span className="text-gray-400 text-sm">
                    {name
                        .split("_")
                        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
                        .join(" ")}
                </span>
            </p>
            <div className="flex justify-between">
                <Button size="sm" colorScheme="gray" variant="outline" onClick={onConfigure}>
                    <BsPlay size="22px" />
                    Configure
                </Button>

                <div className="flex justify-end right-[12px] top-[12px]">
                    <button type="button" onClick={onDelete} className="text-red-400">
                        <BsTrash size={"18px"} />
                    </button>
                </div>
            </div>
        </div>
    );
};

export default Card;
